/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Footer_Designed_ByInputs */

const en_footer_designed_by = /** @type {(inputs: Footer_Designed_ByInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Designed by`)
};

const fr_footer_designed_by = /** @type {(inputs: Footer_Designed_ByInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Conçu par`)
};

const ms_sg2_footer_designed_by = /** @type {(inputs: Footer_Designed_ByInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Direka oleh`)
};

/**
* | output |
* | --- |
* | "Designed by" |
*
* @param {Footer_Designed_ByInputs} inputs
* @param {{ locale?: "en" | "fr" | "ms-SG" }} options
* @returns {LocalizedString}
*/
export const footer_designed_by = /** @type {((inputs?: Footer_Designed_ByInputs, options?: { locale?: "en" | "fr" | "ms-SG" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Footer_Designed_ByInputs, { locale?: "en" | "fr" | "ms-SG" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_footer_designed_by(inputs)
	if (locale === "fr") return fr_footer_designed_by(inputs)
	return ms_sg2_footer_designed_by(inputs)
});